"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * @copyright
 * Copyright (c) 2024 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var svgIconsMapOverrides = {
  search: /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.34,20.06c-.19,0-.38-.07-.53-.22l-3.8-3.78c-1.2.97-2.73,1.55-4.39,1.55-3.86,0-7-3.14-7-7s3.14-7,7-7,7,3.14,7,7c0,1.66-.58,3.19-1.55,4.39l3.8,3.78c.29.29.29.77,0,1.06-.15.15-.34.22-.53.22ZM10.63,5.11c-3.03,0-5.5,2.47-5.5,5.5s2.47,5.5,5.5,5.5,5.5-2.47,5.5-5.5-2.47-5.5-5.5-5.5Z"
  }),
  favorite: /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.9927 21.0901L3.40837 11.8759C1.53054 9.85814 1.53054 6.56903 3.40837 4.55125C4.34145 3.55985 5.57778 3 6.89576 3C8.21373 3 9.46173 3.54818 10.3831 4.55125L11.9927 6.27745L13.6023 4.55125C14.5354 3.55985 15.7717 3 17.0897 3C18.3726 3.03499 19.644 3.54818 20.5771 4.55125C21.4868 5.53098 22 6.83729 22 8.21359C22 9.58988 21.4985 10.8962 20.5771 11.8759L11.9927 21.0901Z"
  }),
  favoriteBorder: /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.9927 21.0901L3.40837 11.8759C1.53054 9.85814 1.53054 6.56903 3.40837 4.55125C4.34145 3.55985 5.57778 3 6.89576 3C8.21373 3 9.46173 3.54818 10.3831 4.55125L11.9927 6.27745L13.6023 4.55125C14.5354 3.55985 15.7717 3 17.0897 3C18.3726 3.03499 19.644 3.54818 20.5771 4.55125C21.4868 5.53098 22 6.83729 22 8.21359C22 9.58988 21.4985 10.8962 20.5771 11.8759L11.9927 21.0901ZM4.59805 10.7562L11.9927 18.6991L19.3874 10.7562C20.0172 10.0797 20.3671 9.17 20.3671 8.20192C20.3671 7.23385 20.0172 6.3241 19.3874 5.64762C18.7692 4.9828 17.9528 4.62123 17.0897 4.62123C16.2266 4.62123 15.4101 4.9828 14.792 5.64762L11.9927 8.64514L9.19347 5.64762C7.95714 4.31798 5.83438 4.31798 4.59805 5.64762C3.29173 7.0589 3.29173 9.34495 4.59805 10.7562Z"
  })
};
var _default = exports.default = svgIconsMapOverrides;